import React, { FC } from "react";

import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import Icon from "@/components/ui/Icon/Icon";
import { socialMediaTracking } from "@/dataLayer/dataLayer";

export interface SocialProps {
  label: string;
  src: string;
  url: string;
}

const FooterSocial: FC<SocialProps> = ({ label, src, url }) => {
  const socialName = src.split(".")[0]?.split("-")[1] ?? "";

  return (
    <AnchorLink href={url} aria-label={label} onClick={(e) => socialName && socialMediaTracking(socialName)}>
      <Icon className="footer-social stroke-white" title={label} name={src} size="32" />
    </AnchorLink>
  );
};

FooterSocial.displayName = "Social";
export default FooterSocial;
